import ChatbotView from './ChatbotView.vue';

export default [
  {
    path: '/app/accounts/:accountId/chatbot',
    name: 'chatbot_index',
    component: ChatbotView,
    meta: {
      requiresAuth: true,
      layout: 'dashboard',
      permissions: ['administrator', 'agent'],
    },
  },
];
